module.exports = __webpack_public_path__ + "static/ycu-logo-254fcd90d1d78aecbb04f8724035d849.jpeg";